import { disableBodyScroll, enableBodyScroll } from './bodyScrollLock';

export default class Modal {
  constructor (element) {
    this._modal = document.querySelector(element)

    // content dialog
    this._dialog = this._modal.querySelector('[data-dialog]')

    this.attachEvent()
  }

  /**
    * Open modal element
   */
  open () {
    disableBodyScroll(this._modal, { reserveScrollBarGap: true })

    this.maskHoverlay(true)
    this._modal.style.display = 'block'

    setTimeout(() => {
      this._modal.classList.add('is-open')
      this._modal.classList.add('fade')
    }, 1)

    this._modal.removeAttribute('aria-hidden')
    this._modal.setAttribute('aria-modal', 'true')
  }

  /**
    * Close modal element
   */
  close () {
    enableBodyScroll(this._modal)

    this.maskHoverlay(false)
    this._modal.setAttribute('aria-hidden', 'true')
    this._modal.removeAttribute('aria-modal')
    setTimeout(() => {
      this._modal.classList.remove('is-open')
      this._modal.classList.remove('fade')
    }, 1)
    this._modal.style.display = 'none'
  }

/**
 * create or remove mask hoverlay
 * @param {Boolean} create
 */
  maskHoverlay (create) {
    if (create) {
      this.mask = document.createElement('div')
      this.mask.classList.add('mask-overlay')
      document.body.append(this.mask)
    } else {
      if (this.mask) this.mask.remove()
    }
  }

/**
 * Create Event for Modal
 */
  attachEvent () {
    // close modal on click outside content
    this._modal.addEventListener('click', (e) => {
      e.preventDefault()
      this.close()
    })

    // stop event on click  inside content dialog
    this._dialog.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
   })

    // element into modal add event close modal
    const eventElements = this._modal.querySelectorAll('[data-modal-event]')
    eventElements.forEach(element => {
      const type = element.getAttribute('data-modal-event')
      if (type === 'close') {
        element.addEventListener('click', (e) => {
          e.preventDefault()
          this.close()
        })
      }
    })
  }
}
